import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	text: {
		fontFamily: "Roboto",
		fontSize: "14px",
		color: "#4b5563",
		marginBottom: "16px",
	},
}));

const ReportSubscriptionsExplanation = () => {
	const { classes } = useStyles();
	return (
		<Typography className={classes.text}>
			Scheduled PDF and Excel reports delivered to your inbox. To subscribe, use
			the report menu (printer icon) on any Defects, Services, or other report
			page.
		</Typography>
	);
};

export default ReportSubscriptionsExplanation;
